<template>
  <div class="greenhouse">
    <v-speed-dial
      v-model="fab"
      top
      right
      direction="bottom"
      :open-on-hover="hover"
      :transition="transition"
    >
      <template v-slot:activator>
        <v-btn v-model="fab" color="cyan darken-1" dark >
          <template v-if="fab">
            <v-icon>
              mdi-menu-up
            </v-icon>
          </template>
          <template v-else>
            <v-icon>
              mdi-menu-down
            </v-icon>
          </template>
            {{ $t("experiment.fab.reference") }}
        </v-btn>
      </template>
      <template>
        <v-btn dark color="indigo" @click="openLabManualDialog();getLabManual()">
          <v-icon>mdi-file-document</v-icon>
          {{ $t("experiment.fab.lab_manual") }}
        </v-btn>
      </template>
      <template>
        <v-btn  dark color="green"  @click="openSetupDialog(); getSetupPhoto()">
          <v-icon> mdi-image-search </v-icon>
          {{ $t("experiment.fab.setup_photo") }}
        </v-btn>
      </template>
      <!--template>
        <v-btn dark color="brown darken-1" @click="getLabManual">
          <v-icon>mdi-play-circle</v-icon>
          Demo Video
        </v-btn>
      </template-->
    </v-speed-dial>
    <v-row>
      <ExperimentTitle />
    </v-row>
    <v-row>
      <v-col xs="12" sm="4">
        <v-card>
          <v-card-text>
            <div>{{ $t('experiment.camera.camera_1_text') }}</div>
            <div class="clickable" @click="popCamera(api.camera_1)">
              <img
                :src="api.camera_1.url"
                ref="camera1Image"
                style="width: 100%; height: auto; object-fit: cover;"
              />
            </div>
          </v-card-text>
        </v-card>
        <v-card>
            <v-card-title>Real-time Values</v-card-title>
            <v-card-text>
            <v-row class="ml-1 mr-1">
              <v-col xs="6">
                <h6><small>Container 1 (More CO2)</small></h6>
                <h6>Temperature 1</h6>
                <h4>{{ temperature_1 }} <small>°C</small></h4>
              </v-col>
              <v-col xs="6">
                <h6><small>Container 2</small></h6>
                <h6>Temperature 2</h6>
                <h4>{{ temperature_2 }} <small>°C</small></h4>
              </v-col>
            </v-row>
            </v-card-text>
        </v-card>
      </v-col>
      <v-col xs="12" sm="8">
        <v-expansion-panels v-model="controlPanel" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header color="green lighten-5">
              <h5>Control</h5>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="control-content">
              <v-card class="p-3">
                <v-overlay absolute :value="loop_flag || loading">
                  <v-btn color="primary">
                    Operating
                    <v-progress-circular
                      indeterminate
                      size="12"
                      class="ma-4"
                    ></v-progress-circular>
                  </v-btn>
                </v-overlay>
                <v-row no-gutters dense>
                  <v-col cols="12">
                    <h5>Status</h5>
                  </v-col>
                </v-row>
                <v-row no-gutters dense>
                  <v-col xs="12" sm="4">
                    Capture: {{ capture_label }}
                  </v-col>
                  <v-col xs="12" sm="4">
                    Light: {{ light_label }}
                  </v-col>
                  <v-col xs="12" sm="4">
                    Fan: {{ fan_label }}
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row>
                  <v-col>
                      <v-checkbox
                        v-model="manual_yaxis"
                        label="Manual Y-axis"
                        hide-details
                        @change="changeYAxis()"
                      >
                      </v-checkbox>
                      <v-expand-transition>
                        <div v-show="manual_yaxis">
                          <v-row class="ml-1 mr-1">
                            <v-col xs="6" class="pb-0">
                            <v-text-field
                              hide-details
                              type="number"
                              v-model="data_1.max"
                              :label="data_1.label_max"
                              class="mx-4"
                            >
                            </v-text-field>
                            </v-col>
                            <v-col xs="6" class="pb-0">
                              <v-text-field
                                hide-details
                                type="number"
                                v-model="data_1.min"
                                :label="data_1.label_min"
                                class="mx-4"
                              >
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <br>
                          <v-row class="ml-1 mr-1">
                            <v-col>
                              <v-btn class='btn' color='green lighten-1' dark @click="changeYAxis()">Apply Y-axis</v-btn>
                            </v-col>
                          </v-row>
                        </div>
                      </v-expand-transition>
                      <br>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row class="mt-3" no-gutters>
                  <v-btn class="mx-4 my-2" @click="clientAction('setCommand', 'device_1', 'MEASURE|1')" color="info" outlined>
                    MEASURE|1
                  </v-btn><v-btn class="mx-4 my-2" @click="clientAction('setCommand', 'device_1', 'MEASURE|2')" color="info" outlined>
                    MEASURE|2
                  </v-btn><v-btn class="mx-4 my-2" @click="clientAction('setCommand', 'device_1', 'MEASURE|3')" color="info" outlined>
                    MEASURE|3
                  </v-btn>
                </v-row>
                <v-divider></v-divider>
                <v-row class="mt-3" no-gutters>
                  <v-col>
                    <v-btn class="mx-4 my-2" @click="downloadZipExperimentData('device_1')" color="primary">
                      Export All Data
                    </v-btn>
                    <!--v-btn class="mx-4" @click="clearCapture" color="error">
                      Clear Graph
                    </v-btn-->
                  </v-col>
                </v-row>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header color="green lighten-5">
              <h5>Measure Result</h5>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <apexchart
                v-if="$i18n.locale=='tc'"
                type="line"
                :options="options_chi"
                :series="series"
                ref="realtimeChart"
              >
              </apexchart>
              <apexchart
                v-else
                type="line"
                :options="options"
                :series="series"
                ref="realtimeChart"
              >
              </apexchart>
              <v-overlay absolute :value="loop_flag || loading">
                <v-btn color="primary">
                  Operating
                  <v-progress-circular
                    indeterminate
                    size="12"
                    class="ma-4"
                  ></v-progress-circular>
                </v-btn>
              </v-overlay>             
            </v-expansion-panel-content>            
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <CameraDialog v-model="camera_dialog" :camera="camera_dialog_camera" />
    <v-dialog v-model="dialog_lab_manual" max-width="700px" >
      <v-card class="pb-3">
        <v-toolbar dark color="green">
          <v-btn icon dark @click="closeLabManualDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("experiment.fab.dialog.lab_manual.header") }}</v-toolbar-title>
        </v-toolbar>
        <v-row justify="center" no-gutters>
          <v-col cols="11"  class="my-2 px-1">
            <v-row>              
              <v-col cols="12">
                <div v-if="lab_manual.school_chi.path!=null || lab_manual.school_en.path!=null">
                  <v-card class="p-1">
                    <v-card-text class="p-1">
                      <v-row>
                        <v-col class="" cols="12">
                          <div v-if="lab_manual.school_en.path!=null">
                            <v-icon class="p-1" color="primary">mdi-file-document-outline</v-icon><a :href="lab_manual.school_en.path" target="_BLANK">{{ lab_manual.school_en.filename }} {{ $t("experiment.fab.dialog.lab_manual.en_label") }}</a>
                          </div>
                          <div v-if="lab_manual.school_chi.path!=null">
                            <v-icon  class="p-1" color="primary">mdi-file-document-outline</v-icon><a :href="lab_manual.school_chi.path" target="_BLANK">{{ lab_manual.school_chi.filename }} {{ $t("experiment.fab.dialog.lab_manual.chi_label") }}</a>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </div>
                <div v-else-if="lab_manual.school_chi.path==null && lab_manual.school_en.path==null">
                  <v-card class="p-1">
                    <v-card-text class="p-1">
                      <v-row>
                        <v-col class="" cols="12">
                          <div v-if="lab_manual.suggested_en.path!=null">
                            <v-icon class="p-1" color="primary">mdi-file-document-outline</v-icon><a :href="lab_manual.suggested_en.path" target="_BLANK">{{ lab_manual.suggested_en.filename }} {{ $t("experiment.fab.dialog.lab_manual.en_label") }}</a>
                          </div>
                          <div v-if="lab_manual.suggested_chi.path!=null">
                            <v-icon  class="p-1" color="primary">mdi-file-document-outline</v-icon><a :href="lab_manual.suggested_chi.path" target="_BLANK">{{ lab_manual.suggested_chi.filename }} {{ $t("experiment.fab.dialog.lab_manual.chi_label") }}</a>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_setup" max-width="800px">
      <v-card>
        <v-toolbar dark color="green">
          <v-btn icon dark @click="closeSetupDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Experiment Setup</v-toolbar-title>
          <!--v-spacer></v-spacer-->
        </v-toolbar>
        <v-carousel v-model="model" height="auto">
          <v-carousel-item
            v-for="(item,i) in setup_photos"
            :key="i"
            :src="item.src"
          >
          </v-carousel-item>
        </v-carousel>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ExperimentTitle from "@/components/ExperimentTitle.vue";
import CameraDialog from "@/components/CameraDialog.vue";
import ExperimentBasic from "@/services/iot/api_basic_experiment";
export default {
  name: "greenhouse",
  components: {
    ExperimentTitle,
    CameraDialog,    
  },
  mixins: [ExperimentBasic],
  data: function () {
    return {
      controlAuth: true,
      model: 0,
      dialog_setup: false,
      dialog_lab_manual: false,
      checkEnd: true,
      direction: 'bottom',
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: true,
      right: true,
      bottom: false,
      left: false,
      transition: 'slide-y-reverse-transition',
      current: {
        username: null,
        user_level: "USER",
        school_id: null,
        auth_token: null,
        experiment: null,
        equipment_id: null,
        booking_id: null,
      },
      controlPanel: [0, 1],
      realTimePanel: 0,
      camera1_url: null,
      stored_data: [["Time", "Set 1 Temperature", "Set 2 Temperature"]],
      is_capturing: false,
      timer: 0,
      counter: 0,
      loop_interval: 10000,
      mounted_interval_1: null,
      mounted_interval_2: null,
      mounted_interval_2: null,
      fan: 0,
      light: 0,
      capture: 0,
      fan_label: "Off",
      light_label: "Off",
      capture_label: "Stopped",
      temperature_1: 0,
      temperature_2: 0,
      data_1: {
        data_max: undefined,
        data_min: undefined,
        max: undefined,
        min: undefined,
        label_max: "Temperature Max",
        label_min: "Temperature Min"
      },
      data_2: {
        data_max: undefined,
        data_min: undefined,
        max: undefined,
        min: undefined,
        label_max: "Temperature Max",
        label_min: "Temperature Min"
      },
      manual_yaxis: false,
      selected_graph: ["Temp_1", "Temp_2"],
      graph_units: {"Temp_1":"°C", "Temp_2": "°C"},
      graph_names: {"Temp_1":"Temperature 1", "Temp_2": "Temperature 2"},
      step_status: "",
      loading: false,
      loop_flag: false,
      setup_photos: [],
      lab_manual:{
        school_chi: { path: null, filename: null },
        school_en: { path: null, filename: null },
        suggested_chi: { path: null, filename: null },
        suggested_en: { path: null, filename: null },
      },
      api: {
        value: "",
        value_got_at: null,
        value_set_at: null,
        camera_1: "",
        camera_2: "",
      },      
      options: {
        colors: ["#FF0000", "#0000FF"],
        width: "100%",
        stroke: {
          width: 1,
        },

        yaxis: {
          title: {
            text: "Temperature (°C)",
          },
        },
        xaxis: {
          type: 'numeric',
          title: {
            text: "Time (s)",
            offsetY: 10,
          },
          tickAmount: 10,
          labels: {
            formatter: function(val) {
              return parseFloat(val).toFixed(0);
            }
          },
        },
      },      
      options_chi: {
        width: "100%",
        stroke: {
          width: 1,
        },yaxis: {
          title: {
            text: "溫度 (°C)",
          },
        },
        xaxis: {
          type: 'numeric',
          title: {
            text: "時間 (s)",
            offsetY: 10,
          },
          tickAmount: 10,
          labels: {
            formatter: function(val) {
              return parseFloat(val).toFixed(0);
            }
          },
        },
      },
      series: [
        {
          name: "Temperature 1",
          data: [],
        },
        {
          name: "Temperature 2",
          data: [],
        },
      ],
    };
  },
  mounted: function () {    
    var self = this;
    self.checkEnd = self.$parent.checkEnd;
    self.current.school_id = self.$store.state.user.school_id;
    self.current.username = self.$store.state.user.username;
    self.current.user_level = self.$store.state.user.user_level;
    self.current.auth_token = self.$store.state.user.auth_token;
    
    self.school_id = self.$route.params.school_id;
    self.experiment = self.$route.query.experiment;
    self.equipment_id = self.$route.query.equipment;
    self.getValue("camera_1", function () {
      self.api.camera_1 = self.api.value;
    });
    self.getValue("device_1", function () {
      self.temperature_1 = self.api.value.Temp_1;
      self.temperature_2 = self.api.value.Temp_2;

      self.light = self.api.value.light;
      self.fan = self.api.value.fan;
      self.capture = self.api.value.capture;

      if (self.light == "0") self.light_label = "Off";
      else if (self.light == "1") self.light_label = "On";
      if (self.fan == "0") self.fan_label = "Off";
      else if (self.fan == "1") self.fan_label = "On";
      if (self.capture == "0") self.capture_label = "Stopped";
      else if (self.capture == "1") self.capture_label = "Capturing";

      self.getChartMultiple("device_1", self.selected_graph.length, self.selected_graph[0], self.selected_graph[1]);
      
    });

    self.checkOverrided();
    
    /*
    self.mounted_interval_1 = setInterval(function () {
      if(self.loop_flag)
//      self.counter++;
      self.getValue("device_1", function () {
        self.light = self.api.value.light;
        self.fan = self.api.value.fan;
        self.capture = self.api.value.capture;

        if (self.light == "0") self.light_label = "Off";
        else if (self.light == "1") self.light_label = "On";
        if (self.fan == "0") self.fan_label = "Off";
        else if (self.fan == "1") self.fan_label = "On";
        if (self.capture == "0") self.capture_label = "Stopped";
        else if (self.capture == "1") self.capture_label = "Capturing";

        setTimeout(function(){
          self.loop_flag = false;
        },4000);
      });
    }, 1000);
    */
    self.mounted_interval_2 = setInterval(function () {
//      self.counter++;
      self.getValue("device_1", function () {
        if (self.api.value_set_at >= self.api.command_set_at) {
            self.loop_flag = false;
        }
        self.temperature_1 = self.api.value.Temp_1;
        self.temperature_2 = self.api.value.Temp_2;
        self.light = self.api.value.light;
        self.fan = self.api.value.fan;
        self.capture = self.api.value.capture;

        if (self.light == "0") self.light_label = "Off";
        else if (self.light == "1") self.light_label = "On";
        if (self.fan == "0") self.fan_label = "Off";
        else if (self.fan == "1") self.fan_label = "On";
        if (self.capture == "0") self.capture_label = "Stopped";
        else if (self.capture == "1") self.capture_label = "Capturing";
      });
    }, 3000);
    self.mounted_interval_3 = setInterval(function(){
      if (self.capture) {
        self.getChartMultiple("device_1", self.selected_graph.length, self.selected_graph[0], self.selected_graph[1]);
      }
    }, 10000);
    self.experiment_name = "GREENHOUSE";
  },
  methods: {    
    openLabManualDialog(){
      var self = this;
      self.dialog_lab_manual = true;
    },
    closeLabManualDialog(){
      var self = this;
      self.dialog_lab_manual = false;
    },
    openSetupDialog(){
      var self = this;
      self.dialog_setup = true;
    },
    closeSetupDialog(){
      var self = this;
      self.dialog_setup = false;
    },
    changeCheck(){
      var self = this;
      self.$emit("changeCheck");
      self.checkEnd = self.$parent.checkEnd;
    },
    changeYAxis(){
      var self = this;
      self.applyManualYAxis("multiple", self.selected_graph.length);
    },
    /*
    startCapture: function(){
      var self = this;
      if(confirm("Starting a new capture will delete your previous data, continue?")){
        self.clearChartMultiple("device_1", 2, ['Temp_1','Temp_2']);
        self.series= [ { name: "Temperature 1", data: [] }, { name: "Temperature 2",data: [] } ];
        setTimeout(function(){
          self.clientSetCommand('device_1', 'CAPTURE|1');
        },500);
      }
    },
    clearCapture: function () {
      var self = this;
      if(self.capture==1){
        alert("Please stop capture before clearing graph.");
      }
      else {
        var r = confirm("Are you sure to clear the graph?");
        if (r == true) {
          self.clearChartMultiple("device_1", 2, ['Temp_1','Temp_2']);
          setTimeout(function(){
            self.series= [ { name: "Temperature 1", data: [] }, { name: "Temperature 2",data: [] } ];
          },500);
        }
      }
    },
    */
  },
  beforeDestroy() {
    if (this.$refs.camera1Image) {
      this.$refs.camera1Image.src = '';
    }
    if (this.$refs.camera2Image) {
      this.$refs.camera2Image.src = '';
    }
  },
  destroyed() {
    //clearInterval(this.mounted_interval_1);
    clearInterval(this.mounted_interval_2);
    clearInterval(this.mounted_interval_3);
  }
};
</script>
<style>
  /* This is for documentation purposes and will not be needed in your application */
  .v-speed-dial {
    position: absolute;
    z-index: 2;
  }

  .v-btn--floating {
    position: relative;
    z-index: 5;
  }
  
  .control-content>.v-expansion-panel-content__wrap{
    padding: 0;
  }
</style>
